import React from 'react';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';

export const ReviewsMasonry = ({
  children,
  actionButton,
  gap = '40px',
}: React.PropsWithChildren<{
  actionButton?: React.ReactNode;
  gap?: string;
}>) => {
  const childrenArray = React.Children.toArray(children);

  if (actionButton) {
    const actionButtonWithKey = (
      <div key="reviews-masonry-action">{actionButton}</div>
    );

    return (
      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 900: 2 }}>
        <Masonry columnsCount={2} gutter={gap}>
          {React.Children.toArray(children).reduce<React.ReactNode[]>(
            (acc, child, index) => {
              if (index === 1) {
                return [...acc, actionButtonWithKey, child];
              }
              return [...acc, child];
            },
            []
          )}
        </Masonry>
      </ResponsiveMasonry>
    );
  }

  return (
    <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 900: 2 }}>
      <Masonry columnsCount={2} gutter={gap}>
        {childrenArray}
      </Masonry>
    </ResponsiveMasonry>
  );
};
